export enum ExportType {
    SUPPLIER_INVOICES = 'SUPPLIER_INVOICES',
    BUYER_INVOICES = 'BUYER_INVOICES',
    BUYER_ACCOUNT_INVOICES = 'BUYER_ACCOUNT_INVOICES',
    BUYER_PAY_LATER = 'BUYER_PAY_LATER',
    BUYER_PAYMENT = 'BUYER_PAYMENT',
    SUPPLIER_PAYMENT = 'SUPPLIER_PAYMENT',
    BUYER_SUPPLIERS = 'BUYER_SUPPLIERS',
    BUYER_CURRENT_BALANCE = 'BUYER_CURRENT_BALANCE',
    SUPPLIER_EARLY_PAYMENT = 'SUPPLIER_EARLY_PAYMENT',
    ASAP_CLIENTS = 'ASAP_CLIENTS',
    ASAP_SCHEDULE_RESULTS = 'ASAP_SCHEDULE_RESULTS',
    ASAP_RULESETS_COMPARISON = 'ASAP_RULESETS_COMPARISON',
    ASAP_RULESET = 'ASAP_RULESET',
    ASAP_DETAILED_REPORT = 'ASAP_DETAILED_REPORT',
    ASAP_SUMMARY_REPORT = 'ASAP_SUMMARY_REPORT',
    ASAP_RULESET_ACTIVITY_HISTORY = 'ASAP_RULESET_ACTIVITY_HISTORY',
    ASAP_CLIENT_ACTIVITY_HISTORY = 'ASAP_CLIENT_ACTIVITY_HISTORY'
}
